import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyBudgetState } from '../components/EmptyBudgetState';
import { useDefaultBudget } from '../hooks/useBudgetQueries';
import { BudgetView } from './BudgetView';

export const CurrentBudget: React.FC = () => {
  const { t } = useTranslation();
  const { data: budget, isLoading } = useDefaultBudget();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-32 w-32 animate-spin rounded-full border-b-2 border-blue-500" />
      </div>
    );
  }

  if (!budget || !budget.id) {
    return (
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white">
            {t('navigation.dashboard')}
          </h1>
        </div>
        <EmptyBudgetState />
      </div>
    );
  }

  return <BudgetView budgetId={budget.id} />;
};
